import { TelesuscripcionAccessRoles } from '../models/api/teladoc/telesuscripcion-access-roles';

/* eslint-disable @typescript-eslint/naming-convention */
export const APP_ROLES = {
  ALL: [
    TelesuscripcionAccessRoles.TELESUSCRIPCIONSUPERVISOR,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONADMIN,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONGESTOR,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONTECNIC,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONBO,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONDT_CAC,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONDT_CATALUÑA,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONDT_CENTROSUR,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONDT_LEVANTE,
    TelesuscripcionAccessRoles.TELESUSCRIPCIONDT_NORTE
  ]
};
